import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import styled from 'styled-components'
import * as _ from 'lodash'
import { RadioGroup, Input, Button } from 'wix-style-react'
import IconIos from 'react-icons/lib/fa/apple'
import IconAndroid from 'react-icons/lib/fa/android'
import FaCheck from 'react-icons/lib/fa/check'

import MessageBoxFunctionalLayout from 'components/shared/MessageBoxFunctionalLayout'
import { getAppInfo } from 'controllers/webSite.js'
import { HELVETICA, TEAL, LIGHT_GRAY, BLUE } from '../../styles'


const Content = styled.div`
  width: 100%;
  height: 36em;
  display: flex;
  flex-direction: column;
  align-items: center;
`
const HeaderText = styled.div`
  width: 100%;
  margin-top: 2em;
  margin-bottom: 2em;
  text-align: center;
  ${HELVETICA};
  font-size: 36px;
  font-weight: 300;
  color: #72a4a3;
`
const DataContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 8
`
const Footer = styled.div`
  width: 95%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  flex: 1
`
const ButtonTransparent = styled.div`
  width: 157px;
  height: 52px;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${LIGHT_GRAY};
  ${HELVETICA};
  font-size: 23px;
  font-weight: 500;
  cursor: pointer;
  border: solid 1px #9b9b9b;
`
const ButtonTeal = ButtonTransparent.extend`
  background-color: ${TEAL};
  color: #FFF;
  border: solid 1px ${TEAL};
`
const RadioGroupContainer = styled.div`
  display: inline-block;
  padding: 0 5px;
  line-height: 22px;
  margin-bottom: 30px;
`
const AppIdContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 70%;
`
const InputContainer = styled.div`
  width: 70%;
`
const CheckContainer = styled.div`
  height: 100%;
`

class MobileAppParamsModal extends Component {

  constructor (props) {
    super(props)
    this.state = {
      platform: 'ios',
      appId: '',
      info: null,
      fetching: false
    }
    this.appInfoCallback = this.onAppInfoReceived
  }

  componentwillUnmount () {
    this.appInfoCallback = () => null
  }

  onAppInfoReceived = (info) => {
    console.log('onAppInfoReceived', info)
    this.setState({
      fetching: false,
      info: info
    })
  }

  onChangePlatform = (v) => this.setState({platform: v})

  renderPlatforms = () => {
    const { platform } = this.state
    return (
      <RadioGroupContainer className='ltr'>
        <RadioGroup
          display='horizontal'
          type='button'
          value={platform}
          onChange={this.onChangePlatform}
        >
          <RadioGroup.Radio
            key='ios'
            value='ios'
            name='ios'
          >
            <IconIos size={30} />
          </RadioGroup.Radio>
          <RadioGroup.Radio
            key='android'
            value='android'
            name='android'
          >
            <IconAndroid size={30} />
          </RadioGroup.Radio>
        </RadioGroup>
      </RadioGroupContainer>
    )
  }

  onInputChange = (e) => this.setState({appId: e.target.value})

  renderAppIdInput = () => {
    return (
      <Input
        size='normal'
        value={this.state.appId}
        onChange={this.onInputChange}
        maxLength={75}
        placeholder='com.company.name'
      />
    )
  }

  renderCheck () {
    const { appId, info } = this.state
    if (_.get(info, 'appId') === appId) {
      return (
        <CheckContainer>
          <FaCheck color={BLUE} />
        </CheckContainer>
      )
    }
  }

  connect = () => {
    console.log('connect')
    const { dispatch } = this.props
    const { platform, appId } = this.state
    this.setState({
      fetching: true,
      info: null
    })
    dispatch(getAppInfo(platform, appId, this.appInfoCallback))
  }

  renderButton () {
    const { appId, fetching } = this.state
    return (
      <Button
        onClick={this.connect}
        disabled={appId === '' || fetching}
      >
        Connect
      </Button>
    )
  }

  renderButtonNext = () => {
    const { handleCreateApp } = this.props
    const { appId, info, platform } = this.state
    if (_.get(info, 'appId') === appId) {
      return (
        <ButtonTeal onClick={() => handleCreateApp(info, platform)}>Next</ButtonTeal>
      )
    }
  }

  renderContent () {
    return (
      <Content>
        <DataContainer>
          <HeaderText>Set your mobile app store params</HeaderText>
          {this.renderPlatforms()}
          <AppIdContainer>
            <InputContainer>
              {this.renderAppIdInput()}
            </InputContainer>
            {this.renderCheck()}
            {this.renderButton()}
          </AppIdContainer>
        </DataContainer>
        <Footer>
          {this.renderButtonNext()}
        </Footer>
      </Content>
    )
  }

  render () {
    const { handleCancel } = this.props
    return (
      <MessageBoxFunctionalLayout
        theme='blue'
        title='Connect your mobile app'
        onCancel={handleCancel}
        disableConfirmation
        hideFooter
        width='60em'
      >
        {this.renderContent()}
      </MessageBoxFunctionalLayout>
    )
  }
}

MobileAppParamsModal.propTypes = {
  handleCancel: PropTypes.func.isRequired,
  handleCreateApp: PropTypes.func.isRequired,
}

export default connect()(MobileAppParamsModal)



// WEBPACK FOOTER //
// ./src/components/dashboard/mobileAppWizard/MobileAppParamsModal.js